import {StyleSheet} from 'react-native';

import {fontFamilyStyle} from '../../components/ui-controls/Text';
import theme from '../../style/theme';

export const styles = StyleSheet.create({
  welcomeContainer: {
    backgroundColor: theme.colour.background.general.primary,
  },
  welcomePrimaryButton: {
    width: '100%',
    padding: theme.size.s3,
    backgroundColor: '#233876',
    borderRadius: theme.size.s2,
  },
  welcomePrimaryButtonTitleStyle: {
    ...fontFamilyStyle,
  },
  rewardsImage: {
    paddingTop: 16,
    height: 61.11,
    width: 92.35,
    alignSelf: 'center',
  },
  rewardsHeading: {
    ...fontFamilyStyle,
    color: 'white',
    fontSize: theme.size.text.heading0,
    fontWeight: '700',
  },
  rewardsHeadingContainer: {
    marginTop: theme.size.s5,
    marginBottom: theme.size.s5,
  },
  lightOnDark: {
    ...fontFamilyStyle,
    color: 'white',
    fontSize: theme.size.text.body2,
    lineHeight: 24,
  },
  debugContainer: {
    alignSelf: 'flex-start',
    marginLeft: 8,
  },
  button: {
    marginTop: 16,
  },
  checkbox: {
    alignSelf: 'flex-start',
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 8,
  },
  compromisedPasswordText: {
    alignSelf: 'center',
    color: 'red',
    flex: 1,
    fontSize: 12,
    justifyContent: 'center',
    marginBottom: 4,
    marginLeft: 8,
  },
  mobileContainerStyle: {
    paddingHorizontal: 0,
  },
  mobileInputStyle: {
    ...fontFamilyStyle,
    backgroundColor: 'white',
    borderRadius: theme.size.s2,
    paddingHorizontal: theme.size.s4,
    paddingVertical: theme.size.s3,
  },
  mobileInputContainerStyle: {
    borderBottomWidth: 0,
  },
  mobileLabelStyle: {
    ...fontFamilyStyle,
    marginBottom: theme.size.s2,
    fontWeight: '400',
    color: 'white',
  },
  mobileErrorStyle: {
    ...fontFamilyStyle,
    color: 'white',
  },
  dateOfBirthContainer: {
    // Bug: dropdowns fall behind other content in react-navigation draw menu components #248
    // https://github.com/hossein-zare/react-native-dropdown-picker/issues/248
    zIndex: 1000,
  },
  dateOfBirthInput: {
    width: '100%',
    paddingHorizontal: 8,
  },
  errorMessage: {
    marginVertical: 8,
    fontSize: 14,
    color: '#E02424',
  },
  formElement: {
    marginTop: 8,
  },
  label: {
    paddingHorizontal: 10,
    color: 'rgb(134, 147, 158)',
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  suburbsPicker: {
    borderColor: 'grey',
    borderWidth: 0.5,
    borderRadius: 4,
  },
  suburbsDropDownContainerStyle: {
    borderColor: 'grey',
    borderWidth: 0.5,
    borderRadius: 4,
  },
  suburbsSearchContainerStyle: {
    borderBottomWidth: 0.5,
  },
  suburbsSearchTextInputStyle: {
    borderColor: 'grey',
    borderWidth: 0.5,
    borderRadius: 4,
  },
  suburbsContainerStyle: {
    minHeight: 50,
  },
  suburbsItemSeparatorStyle: {
    backgroundColor: 'transparent',
    borderColor: 'grey',
    borderBottomWidth: 0.5,
  }
});
